let BaseUrl = null;
let hostName = window.location.origin;
if (process.env.NODE_ENV === "production") {
  BaseUrl = hostName;
} else {
  BaseUrl = "https://aqd.systems.gov.bt";
}

export let Action = {
  Base: BaseUrl,

  GeoServerBaseSmog: "https://smog.icimod.org/geoserver",

  CityData: "apps/airqualitybt/getCityData",
  Aeronet: "apps/airqualitybt/aeronetaodpm",
  USEmbassyAOD: "apps/airqualitybt/usembassypm",
  getGeoJSONofStations: "apps/airqualitybt/getGeoJSONofStations",
  getGeoJsonForOneSatation: "apps/airqualitybt/getGeoJsonForOneSatation",
  getAllStationsID: "apps/airqualitybt/getAllStationsID",

  commonAPI: "apps/airqualitybt/getData/",
  RegionGeojson: "apps/airqualitybt/geojsonregion",
  AOIPolygon: "apps/airqualitybt/aoipolygon",
  GetMapImage: "apps/airqualitybt/getmapimage/",
  GetImage: "apps/airqualitybt/downloadImage",
  SlicedFromCatalog: "apps/airqualitybt/slicedfromcatalog/",
  SliceFromCatalogForecast: "apps/airqualitybt/SliceFromCatalogForecast/",
  TimeSeriesRasterQuery: "apps/airqualitybt/timeseriesmodeldata/",
  trueColorLegendImage: "apps/airqualitybt/trueColorLegendImage/",
  defaultObservationStation: "apps/airqualitybt/defaultobservationstation/",

  //emission
  CascaderOptions: "apps/airqualitybt/getCascaderData/",
  ChartDataProcess: "apps/airqualitybt/getChartDataProcess/",
  LayerInfoStat: "apps/airqualitybt/getLayerInfoStat/",
  createGIFMapImage: "apps/airquality/creategifmapimage/",
};
